import { useQuery } from "@tanstack/react-query";
import RevealReportContent from "components/organisms/pregnancy/RevealReportContent";
import { PregnancyAnnounceReportModel } from "models/pregnancyAnnounceReportModel";
import { getRequest } from "util/request/request";

const RevealReport = () => {
  const { data } = useQuery<PregnancyAnnounceReportModel>({
    queryKey: ["pregnancyAnnounceReport"],
    queryFn: () =>
      getRequest({
        url: "/api/d/diary/pregnancyReady/pregnancyAnnounceReport",
      }),
  });

  return <RevealReportContent data={data} />;
};

export default RevealReport;
